
  var iFrameForm = document.querySelector('.popup-homepage');
  var overlay = document.querySelector('.overlay');
  var stopScroll = document.querySelector('.learn-photography-company');
  var closeBtn = document.querySelector('.close-popup');
  var closeBtn2 = document.querySelector('.close-btn-saf');

  
    overlay.style.visibility='visible';
    overlay.style.opacity=1;
    iFrameForm.style.display='block';
    stopScroll.classList.add('stop-scroll');
    

  overlay.addEventListener('click',function(){
    overlay.style.opacity=0;
    iFrameForm.style.display='none';
     overlay.style.visibility='hidden';
     stopScroll.classList.remove('stop-scroll');
    closeBtn.style.display='none';
  });
  closeBtn.addEventListener('click',closePopup);
  closeBtn2.addEventListener('click',closePopup);

function closePopup(){
   overlay.style.opacity=0;
    iFrameForm.style.display='none';
     overlay.style.visibility='hidden';
     stopScroll.classList.remove('stop-scroll');
    closeBtn.style.display='none';
}

$(document).ready(function() {
  function adjustPopupPosition() {
    var scrollTop = $(window).scrollTop();
    
    if (scrollTop > 0) {
      // Adjust the top position based on scroll distance
      $('.popup-homepage').css('top', 400 + scrollTop + 'px');
    }
  }

  // Adjust position on page load
  adjustPopupPosition();

  // Adjust position on scroll
  $(window).scroll(function() {
    adjustPopupPosition();
  });
});
// Home Page popup end



